'use strict';

const priceSlider = require('./priceSlider');
const searchFilter = require('./searchFilter');
const filtersCustom = require('./filtersCustom');
const analyticsHelper = require('../util/analyticsHelper');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');

    var noResults = $('.filter-title-container.no-results');

    if($('.refinements').is(':empty')) {
        noResults.removeClass('d-none');
    }
    else {
        noResults.addClass('d-none');
    }

    initPriceSlider();
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.result-count',
        '.breadcrumb-container'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    filtersCustom.initFilterTools();
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Handle sort order menu selection
 */
function sort() {
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

/**
 * Show more products
 */
function showMore() {
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                updateSortOptions(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

/**
 * Creates the price slider instance and sets the configuration
 */
function initPriceSlider() {
    priceSlider.initSlider(parseResults);
}

/**
 * Refinements selection handler
 * @param {*} event - Click event
 */
function handleRefinementSelection(event) {
    searchFilter.send(event, $(this), parseResults);
}

/**
 * Handle refinement value selection and reset click
 */
function applyFilter() {
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        handleRefinementSelection
    );
}

/**
 * Pop State event handler, updates URL
 */
function onPopState() {
    $(window).on('popstate', function () {
        window.location = window.location.href;
    });
}

/**
 * adds quantity and pid to PLP add to cart event.
 * @param {event} event - button trigger event
 * @param {Object} form - holds the product info
 */
function handleUpdateAddToCartFormData(event, form){
    var isPLP = $('.container.search-results').length > 0;
    var minQty = parseInt($(this).data('min-order-quantity'), 10) || 1;
    var stepQty = parseInt($(this).data('step-quantity'), 10) || 1;

    if(isPLP) {
        form.quantity = minQty * stepQty;
        form.pid =  $(this).data('pid');
    }
}

/**
 * inits PLP add to cart event
 */
function initAddToCartButtonInPlp(){
    $('button.add-to-cart, button.add-to-cart-global').on("updateAddToCartFormData", handleUpdateAddToCartFormData)
}

/*
 * Updates the content result count in the UI.
 * This function retrieves the content count from a data attribute,
 * formats it with the appropriate text, and updates the display.
 */
function updateResultCount() {
    const $contentResultCount = $('.content-result-count');
    const contentCount = parseInt($('#blogEntriesContainer').data('contentCount'), 10);
    var articleText = $contentResultCount.data('articles');
    if (contentCount === 1) {
        articleText = articleText.slice(0,-1)
    }
    $contentResultCount.html('(' + contentCount + ' ' + articleText + ')');
}

/**
 * Toggles the visibility of search count elements in the UI.
 */
function toggleSearchCount() {
    $('.content-result-count').toggle();
    $('.search-result-count').toggle();
    $('.content-tab-count').toggle();
    $('.product-tab-count').toggle();
}

/**
 * Handles the click event on the product search tab.
 * This function toggles the search count display when the product search tab is clicked.
 * @param {Event} e - The click event object
 */
function handleProductSearchClick(e) {
    toggleSearchCount();
}

/**
 * Retrieves and appends content search results via an AJAX call.
 * This function handles both initial content loading and "Load More" functionality.
 * @param {jQuery} $element - The jQuery element that triggered the content load
 * @param {jQuery} $target - The jQuery element where the content will be appended
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            if ($('#content-search-results').html() !== '') {
                var $tempDiv = $('<div>').html(response);
                var $contentToAppend = $tempDiv.find('#blogEntriesContainer').children();
                var $showMoreButton = $tempDiv.find('.show-more-content');
                $target.append($contentToAppend);
                $target.after($showMoreButton);
                toggleSearchCount()
            } else {
                $target.append(response);
            }
            toggleSearchCount()
            $.spinner().stop();
            updateResultCount();
        },
        error: function () {
            $.spinner().stop();
            const errorMessage = $('#content-search-results').data('error-msg');
            $target.append('<p>' + errorMessage + '</p>');
        }
    });
}

/**
 * Initializes and handles events for the content search tab.
 */
function showContentTab() {
    $('.container').on('click', '.nav-tabs .content-search', function () {
        if ($('#content-search-results').html() === '') {
            getContent($(this), $('#content-search-results'));
        } else {
            toggleSearchCount()
        }
    });

    // Display the next page of content results from the search
    $('.container').on('click', '.show-more-content button', function () {
        getContent($(this), $('#blogEntriesContainer'));
        $('.show-more-content').remove();
    });

    $('.nav-tabs .product-search').on('click', handleProductSearchClick);
}

/**
 * Triggers a Google Analytics event for viewing  product list
 *
 * @function triggerViewListProductEvent
 * @fires analyticsHelper.trackEvent
 * @event view_product_list
 */
function triggerViewListProductEvent() {
    const productResultsFound = !$('.search-not-found:visible').length;
    if (productResultsFound) {
        analyticsHelper.trackEvent('view_item_list');
    }
}

module.exports = {
    sort,
    showMore,
    applyFilter,
    showContentTab,
    onPopState,
    initPriceSlider,
    initAddToCartButtonInPlp,
    triggerViewListProductEvent
};
